import { render, staticRenderFns } from "./OverallUpload.vue?vue&type=template&id=48b09d58&scoped=true"
import script from "./OverallUpload.vue?vue&type=script&lang=js"
export * from "./OverallUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b09d58",
  null
  
)

export default component.exports